import { Student } from '../_models/student';
import { Observable } from 'rxjs';
import {DbService,STUDENT_STORE_NAME, STUDENT_STORE_INDEX_BATCH } from './DbService';
import TimetableService from './TimeTableService';

class StudentService {
  dbservice:DbService = new DbService()
  constructor(){
    this.dbservice.connect()
  }
  getStudents(): Promise<Student[]> {
    return this.dbservice.getAll(STUDENT_STORE_NAME);
  }

  /*toggleToDo(student: Student): Observable<void> {
    return this.dbService.save(STUDENT_STORE_NAME, {
      ...student,
      done: !toDo.done,
    });
  }*/

  addStudent(name: string, studentCode: string, batchId: number): Promise<void> {
    return this.dbservice.save(STUDENT_STORE_NAME, {
      name,
      studentCode,
      batchId,
    });
  }

  addstudents(students: Student[]): any {
    return this.dbservice.saveAll(STUDENT_STORE_NAME, students);
  }

  getStudentsForBatch(batchId: number): Promise<Student[]> {
    return this.dbservice.getByIndex(STUDENT_STORE_NAME, STUDENT_STORE_INDEX_BATCH, batchId);
  }
}

export default StudentService